export default __webpack_public_path__ + "static/media/icon-social.86f9f479.png";